const translations = {
    pt: {
        productList: "Lista de Produtos",
        typeFilter: "Tipo de Produto",
        all: "Todos",
        nameFilter: "Nome",
        activeIngredientFilter: "Ingrediente Ativo",
        searchButton: "Buscar",
        fertilizer: "Fertilizante",
        pesticide: "Biodefensivo Agrícola",
        name: "Nome",
        activeIngredient: "Ingrediente Ativo",
        type: "Tipo",
        actions: "Ações",
        view: "Visualizar",
        link: "Anexar",
        delete: "Deletar",
        noProducts: "Nenhum produto encontrado.",
        previous: "Anterior",
        next: "Próximo",
        successDelete: "Produto deletado com sucesso!",
        errorDelete:
            "Não foi possível excluir o produto. Verifique se há capítulos vinculados a ele.",
        placeholderName: "Digite o nome do produto",
        placeholderActiveIngredient: "Digite o ingrediente ativo",
        productInfo: "Editar Produto",
        productType: "Tipo de Produto*",
        description: "Descrição*",
        storageMethod: "Método de Armazenamento*",
        formulation: "Formulação*",
        controlTarget: "Alvo de Controle*",
        activeConcentration: "Concentração Ativa*",
        recommendedDose: "Dose Recomendada*",
        applicationMethod: "Método de Aplicação*",
        benefit: "Benefícios*",
        saveButton: "Salvar Alterações",
        cancelButton: "Cancelar",
        successUpdate: "Produto atualizado com sucesso!",
        errorUpdate:
            "Falha ao atualizar o produto. Verifique os dados e tente novamente.",
        missingFields: "Campos obrigatórios faltando:",
        addProduct: "Adicionar Produto",
        addButton: "Adicionar",
        successAdd: "Produto adicionado com sucesso!",
        errorAdd:
            "Falha ao adicionar o produto. Verifique os dados e tente novamente.",
        placeholderDescription: "Descreva o produto",
        placeholderStorageMethod: "Ex.: Armazenar em local seco e fresco",
        placeholderFormulation: "Ex.: Líquido, Granulado",
        placeholderControlTarget: "Ex.: Pragas, Doenças",
        placeholderActiveConcentration: "Ex.: 100 g/L",
        placeholderRecommendedDose: "Ex.: 1 L/ha",
        placeholderApplicationMethod: "Ex.: Pulverização foliar",
        placeholderBenefit: "Descreva os benefícios do produto",
        confirmDelete: "Confirmar Exclusão",
        confirmDeleteMessage: "Tem certeza que deseja deletar este produto?",
        confirmButton: "Confirmar",
        linkTo: "Vincular \"",
        toChapter: "\" a um capítulo...",
        selectBook: "Selecione um Livro",
        selectChapter: "Selecione um Capítulo",
        linkButton: "Vincular",
        chapterProducts: "Produtos Vinculados a este Capítulo",
        productChapters: "Capítulos Vinculados a este Produto",
        noBooks: "Nenhum livro encontrado.",
        noChapters: "Nenhum capítulo encontrado.",
        noLinkedProducts: "Nenhum produto vinculado.",
        noLinkedChapters: "Nenhum capítulo vinculado.",
        successLink: "Produto vinculado com sucesso!",
        errorLink: "Falha ao vincular o produto.",
        successUnlink: "Capítulo desvinculado com sucesso!",
        errorUnlink: "Falha ao desvincular o capítulo.",
        selectBookPrompt: "Selecione um livro",
        selectChapterPrompt: "Selecione um capítulo",
        loading: "Carregando...",
        unlinkButton: "Desvincular",
        showing: "Mostrando",
        of: "de",
        products: "produtos",
        failedToFetch: "Falha ao buscar produtos."
    },
    en: {
        productList: "Product List",
        typeFilter: "Product Type",
        all: "All",
        nameFilter: "Name",
        activeIngredientFilter: "Active Ingredient",
        searchButton: "Search",
        fertilizer: "Fertilizer",
        pesticide: "Bioagricultural Pesticide",
        name: "Name",
        activeIngredient: "Active Ingredient",
        type: "Type",
        actions: "Actions",
        view: "View",
        link: "Attach",
        delete: "Delete",
        noProducts: "No products found.",
        previous: "Previous",
        next: "Next",
        successDelete: "Product deleted successfully!",
        errorDelete:
            "Failed to delete the product. Please check if there are any chapters linked to it.",
        placeholderName: "Enter the product name",
        placeholderActiveIngredient: "Enter the active ingredient",
        productInfo: "Edit Product",
        productType: "Product Type*",
        description: "Description*",
        storageMethod: "Storage Method*",
        formulation: "Formulation*",
        controlTarget: "Control Target*",
        activeConcentration: "Active Concentration*",
        recommendedDose: "Recommended Dose*",
        applicationMethod: "Application Method*",
        benefit: "Benefits*",
        saveButton: "Save Changes",
        cancelButton: "Cancel",
        successUpdate: "Product updated successfully!",
        errorUpdate:
            "Failed to update the product. Please check the data and try again.",
        missingFields: "Required fields missing:",
        addProduct: "Add Product",
        addButton: "Add",
        successAdd: "Product added successfully!",
        errorAdd:
            "Failed to add the product. Please check the data and try again.",
        placeholderDescription: "Describe the product",
        placeholderStorageMethod: "Ex.: Store in a cool, dry place",
        placeholderFormulation: "Ex.: Liquid, Granular",
        placeholderControlTarget: "Ex.: Pests, Diseases",
        placeholderActiveConcentration: "Ex.: 100 g/L",
        placeholderRecommendedDose: "Ex.: 1 L/ha",
        placeholderApplicationMethod: "Ex.: Foliar spray",
        placeholderBenefit: "Describe the product benefits",
        confirmDelete: "Confirm Deletion",
        confirmDeleteMessage: "Are you sure you want to delete this product?",
        confirmButton: "Confirm",
        linkTo: "Link \"",
        toChapter: "\" to a chapter...",
        selectBook: "Select a Book",
        selectChapter: "Select a Chapter",
        linkButton: "Link",
        chapterProducts: "Products Linked to This Chapter",
        productChapters: "Chapters Linked to This Product",
        noBooks: "No books found.",
        noChapters: "No chapters found.",
        noLinkedProducts: "No products linked.",
        noLinkedChapters: "No chapters linked.",
        successLink: "Product linked successfully!",
        errorLink: "Failed to link the product.",
        successUnlink: "Chapter unlinked successfully!",
        errorUnlink: "Failed to unlink the chapter.",
        selectBookPrompt: "Select a book",
        selectChapterPrompt: "Select a chapter",
        loading: "Loading...",
        unlinkButton: "Unlink",
        showing: "Showing",
        of: "of",
        products: "products",
        failedToFetch: "Failed to fetch products."
    },
};

export default translations;